const CONFIG = {
 // PATH_API: "http://localhost:3000",
 PATH_API: "https://tworenov-backend.onrender.com",

 
};

export default CONFIG;